module.exports = __webpack_public_path__ + "static/BackgroundAbout-a663cce9cacd02a6a6fcfc9e57c5d155.jpg";